// Module
var code = `<breadcrumbs></breadcrumbs>
<section id="customer-risk-profile" class="box">
  <sub-header header="'Risk Assessment'"></sub-header>
  <form name="\$ctrl.form">
    <table class="table table-style risk-assessment__table">
      <thead>
      <tr>
        <th>Risk weight</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr ng-repeat="e in \$ctrl.sortedEntries">
        <td>
          <select
            ng-model="e.riskDictionaryEntryId"
            ng-options="de.id as de.code for de in \$ctrl.riskDictionaryEntries"
            required
            disabled="disabled">
          </select>
        </td>
        <td>
          <input type="number"
                 required
                 step="0.01"
                 min="0"
                 ng-change="\$ctrl.validateRiskWeight()"
                 ng-class="{'ng-invalid': !e.isValid}"
                 ng-model="e.weight"/>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="table table-style risk-assessment__table">
      <thead>
      <tr>
        <th>Risk level</th>
        <th>Min. points</th>
        <th>Max. points</th>
      </tr>
      </thead>
      <tbody>
      <tr ng-repeat="e in \$ctrl.sortedEntries">
        <td>
          <select
            ng-model="e.riskDictionaryEntryId"
            ng-options="de.id as de.code for de in \$ctrl.riskDictionaryEntries"
            required
            disabled="disabled">
          </select>
        </td>
        <td>
          <input type="number"
                 ng-class="{'ng-invalid': !\$ctrl.isMinPointsGtPreviousMaxPoints(\$index)}"
                 required
                 step="0.01"
                 ng-model="e.minPoints"/>
        </td>
        <td>
          <input type="number"
                 required
                 ng-class="{'ng-invalid': !\$ctrl.isMaxPointsGteMinPoints(\$index)}"
                 step="0.01"
                 ng-model="e.maxPoints"/>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="clearfix"></div>

    <div class="buttons">
      <button class="btn btn-warning"
              ng-click="\$ctrl.goBack()">
        Cancel
      </button>
      <button class="btn btn-primary"
              command-access="UpdateRiskAssessments"
              ng-disabled="\$ctrl.form.\$invalid || \$ctrl.form.\$pristine"
              ng-click="\$ctrl.save()">
        Save
      </button>
    </div>

    <validator condition="\$ctrl.areAllEntriesValid()" />
  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/risk-assessment/risk-assessment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;